document.addEventListener('DOMContentLoaded', () => {
  const featuresHeaderColsContainer = document.querySelector(
    '.features-header-cols-container'
  );
  const featuresHeaderDesktopCol = document.querySelector(
    '.features-header-desktop-col'
  );

  if (featuresHeaderColsContainer) setTimeout(resizeContainer, 500);

  function resizeContainer() {
    window.requestAnimationFrame(() => {
      const w =
        window.innerWidth ||
        document.documentElement.clientWidth ||
        document.body.clientWidth;
      if (w >= 800) {
        featuresHeaderColsContainer.style.height = `${featuresHeaderDesktopCol.offsetHeight -
          310}px`;
      } else {
        featuresHeaderColsContainer.style.height = `auto`;
      }
    });
  }

  window.addEventListener('resize', () => {
    const w =
      window.innerWidth ||
      document.documentElement.clientWidth ||
      document.body.clientWidth;
    if (featuresHeaderColsContainer) resizeContainer();
  });
});
